import React, { useState, useCallback, useLayoutEffect, useEffect } from 'react';
import StoreInfo from '../components/StoreInfo';
import StoreSearch from '../components/StoreSearch';
import StoreList from '../components/StoreList';
import UpdateStore from '../components/UpdateStore';
import { StoreInfoApi, StoreSearchApi } from '../api/StoreAPI';
import UPDATED_STORE from '../libs/updatedStore';

const StoreInfoPage = ({ match }) => {

  const [store_info, setStoreInfo] = useState({
    id: 'noimg',
    name: '-',
    category: '-',
    url: ' ',
    description: ["-", "-"],
    mcpnm: '-'
  });

  const [search_info, setSearchInfo] = useState({
    area: 0,
    search_text: '',
  });

  const [search_button_disable, setButtonDisable] = useState(true);
  const [store_list, setStoreList] = useState([]);
  const [loading, setLoading] = useState(true);

  // 추후 업데이트 예정, true:업데이트 된 상태, false: 업데이트 전
  const [updated_store, setUpdateStore] = useState(true);

  useLayoutEffect(() => {
    StoreInfoApi(match.params.store_id, setStoreInfo, setLoading);
    if (UPDATED_STORE.indexOf(match.params.store_id) < 0) {
      setUpdateStore(false);
    }
  }, [match.params.store_id]);

  useEffect(() => {
    if (search_info.search_text === '') {
      setButtonDisable(true);
    } else {
      setButtonDisable(false);
    }
  }, [search_info]);

  const handleSearchButton = useCallback((e) => {
    if (search_info.search_text.length < 2) {
      alert("두 글자 이상 입력해주세요");
      return false;
    }
    StoreSearchApi(store_info.mcpnm, search_info, setStoreList);
  });

  const handleSearchInput = useCallback((e) => {
    setSearchInfo({
      ...search_info,
      [e.target.name]: e.target.value,
    });
  });


  if (loading) {
    return (
      <></>
    )
  }
  return (
    <div id="wrap">
      <div className="container">
        <div className="store_info_box">
          <StoreInfo store_info={store_info} />
          {updated_store ? (
            <StoreSearch
              updated_store={updated_store}
              handleSearchInput={handleSearchInput}
              button_disable={search_button_disable}
              handleSearchButton={handleSearchButton}
            />
          ) : null}
        </div>
        {updated_store ? <StoreList store_list={store_list} /> : null}
      </div>
    </div>
  );
};

export default StoreInfoPage;
